<template>
  <v-main>
    <FwUpdateDetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      @rowClicked="showRowDetails"
    />
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import FwUpdateDetailsDialog from './FwUpdateDetailsDialog.vue'
import adapterSpec from './fw-updates-columns'

export default {
  pageTitle: 'Histórico de FW Updates',
  components: {
    GenericReport,
    FwUpdateDetailsDialog
  },
  data() {
    return {
      reportSpec: {
        code: 'globalFWUpdates',
        title: 'Histórico de FW Updates',
        apiBase: '/firmware-updates',
        filters: [{ type: 'Firmware', prefix: 'firmwareId', noSuffix: true }]
      },

      adapterSpec
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
